<template>
  <div>
    <ul class="breadBox">
      <li v-for="(item,index) in breadList" :key="index">
        <router-link :to="item.path" v-if="item.link">{{item.name}}</router-link>
        <span v-else>{{item.name}}</span>
        <span class="breadBreak" v-if="index != breadList.length -1">/</span>
      </li>
    </ul>
  </div>
</template>
<script> 
export default{
    name:'breadCrumb',
    props:{
      breadList:{
          type:Array,
          require:true,
          default:()=>{
              return [
              {name:'首页',path:'/home',link:false},  //link :标识是否需要跳转路由 一级菜单不需要
          ]
      }
      }
    },
    data(){
        return{
         
        }
    }
}
 
</script>
<style scoped>
.breadBox{
    overflow: hidden;
    padding: 24px  24px 16px; 
    background: #fff; 
}
.breadBox li{
    float: left;
    font-size: 14px;
    color: #666;
}
.breadBox li a{
   color: #333;
   text-decoration: none;
}
.breadBreak{
    padding: 0 5px;
}
</style>
